import { render, staticRenderFns } from "./user-personaldetails.vue?vue&type=template&id=6d913190&scoped=true"
import script from "./user-personaldetails.vue?vue&type=script&lang=js"
export * from "./user-personaldetails.vue?vue&type=script&lang=js"
import style0 from "./user-personaldetails.vue?vue&type=style&index=0&id=6d913190&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d913190",
  null
  
)

export default component.exports